import React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { CircularProgress } from 'modules/utils/cp3/components/CircularProgress';
import { lStorage } from 'modules/utils/LocalStorage/LocalStorageHelper';

import { getCP3Env } from '../CP3Config';

const getUserToken = gql`
	{
		token: userTokenForLavuAPI
	}
`;

const redirectWithToken = ({ token }) => {
	window.location = `${getCP3Env('REACT_APP_LAVU_API_URL')}/oauth/authorize${
		window.location.search ? `${window.location.search}&` : '?'
	}authorize_jwt=${token}`;
};

/**
 * This component has the purpose to redirect to LavuAPI authorization providing a
 * valid JWT token if session in CP4 exists, otherwise it will just redirect to the
 * root of Lavu API.
 *
 * https://jira.lavu.com/browse/CP3-2182
 */
const ThirdPartyAuth = () => {
	const { user } = lStorage.get({ key: 'current-user' });

	if (!user) {
		// No need to even hit Hubql if no user is present
		window.location = `${getCP3Env('REACT_APP_LAVU_API_URL')}/oauth/authorize${window.location.search}`;
		return <CircularProgress centered />;
	}

	return (
		<Query query={getUserToken} onCompleted={redirectWithToken}>
			{() => <CircularProgress centered />}
		</Query>
	);
};

export default ThirdPartyAuth;
